
import React, { useContext, useState, useRef, useMemo, useEffect } from "react";
import './HomeAddresses.css'
import { mobileStyle } from "../../Home";
import { useMediaQuery } from "react-responsive";
import { Helmet } from "react-helmet-async";
import AuthContext from "../../../../store/auth-context";
import { useLocation, useNavigate } from "react-router-dom";
import LoadingScreen from "../../LoadingScreen/Loading";
import { Country, State, City } from 'country-state-city';
import userServices from "../../../../services/user-services";
import logger from "../../../../utils/logger";
import constants from "../../../../constants/en";

const ShowShippingAddress = () => {
  const primaryColor = mobileStyle.color[1];
  const primaryBackgroundColor = "var(--pure-white)";
  const redColor = mobileStyle.color[0];
  const isMobile = useMediaQuery({
    maxWidth: 768
  })

  const { state } = useLocation();
  const authCtx = useContext(AuthContext);
  //   const { itemId, causeId, auctionId } = state;
  const [toFirstName, setToFirstName] = useState('');
  const [toLastName, setToLastName] = useState('');
  const [address1, setAddress1] = useState('');
  const [address2, setAddress2] = useState('');
  const [zip, setZip] = useState('');
  const [phone, setPhone] = useState('');
  const [email, setEmail] = useState('');
  const phoneRef = useRef();
  const [country, setCountry] = useState('US');
  const [cityState, setCityState] = useState('');
  const [city, setCity] = useState('');
  const [alertMsg, setAlertMsg] = useState(null)
  const [alert, setAlert] = useState(false);
  const [isLoading, setIsLoading] = useState(false)
  const location = useLocation();
  const codesObj = {};

  Country.getAllCountries().forEach((item) => {
    codesObj[item.isoCode] = item.phonecode;
  });

  useEffect(() => {

    try {
      (async () => {
        setIsLoading(true)
        const { data } = await userServices.getUserShippingAddress(
          authCtx?.userId
        );
        if (data) {
          setToFirstName(data.to_firstname);
          setToLastName(data.to_lastname);
          setAddress1(data.address1);
          setAddress2(data.address2);
          setCity(data.city);
          setCountry(data.country);
          setPhone(data.phone);
          setZip(data.zip);
          setEmail(data.email)
          setCityState(data.state);
          setIsLoading(false)
        }
      })();
    }
    catch (error) {
      setAlertMsg("Something went wrong")
      setAlert(true)
    }
    finally {
      setIsLoading(false)
    }
  }, [])


  return (
    <>

      <div className="container-payment-show">
        <div>
          <div className='payment-card' style={{ backgroundColor: "white" }}>
            <div className='bag_shipping_content' style={{ fontSize: "1rem" }}>
              <div>{toFirstName} {toLastName}</div>
              <div>{address1}</div>
              <div>{address2}</div>
              <div>{city}</div>
              <div>{cityState || ''}</div>
              <div>{zip}</div>
            </div>
          </div>
        </div>
      </div>
    
  </>
  )
}


export default ShowShippingAddress
